import * as React from "react";
import RaisedButton from "material-ui/RaisedButton";

interface StepActionsProps {
    disabled?: boolean;
    label: string;
    onAction(): void;
}

export class StepActions extends React.Component<StepActionsProps, {}> {

    render() {
        const styles = this.getStyles();

        return (
            <div style={styles.callToActionPanel}>
                <RaisedButton label={this.props.label}
                              onTouchTap={this.props.onAction}
                              disabled={this.props.disabled}
                              primary={true} />
            </div>
        );
    }

    private getStyles() {
        return {
            callToActionPanel: {
                height: "52px",
                textAlign: "right",
                padding: "8px 8px 8px 0",
                borderTop: "1px",
                borderTopColor: "#d9d9d9",
                borderTopStyle: "solid"
            },
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/components/StepActions.tsx
 **/